var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import t from '../lib/translate';
var InputCheckbox = function (_a) {
    var options = _a.options, handleChange = _a.handleChange, toggle = _a.toggle, className = _a.className, children = _a.children;
    return (_jsxs("div", __assign({ className: "input-checkbox ".concat(className !== null && className !== void 0 ? className : '') }, { children: [options === null || options === void 0 ? void 0 : options.map(function (option) { return (_jsxs("div", __assign({ className: 'checkbox' }, { children: [_jsx("input", { type: 'checkbox', name: option.name, id: option.name, checked: option.value, onChange: handleChange, className: classNames(className, { toggle: toggle }) }), _jsx("label", { className: classNames('toggle-button', className), htmlFor: option.name }), _jsx("label", __assign({ className: classNames(className), htmlFor: option.name }, { children: t(option.label) }))] }), option.name)); }), children] })));
};
export default InputCheckbox;
